"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.AssetRequest = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseFilters = require("nicbase-filters");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var portals = state.portals,
      user = state.user;
  return {
    portals: portals,
    user: user
  };
};

exports.mapStateToProps = mapStateToProps;

var AssetRequest = function AssetRequest(_ref) {
  var tour = _ref.tour,
      portals = _ref.portals,
      user = _ref.user,
      onAssetChange = _ref.onAssetChange;
  var _tour$name = tour.name,
      name = _tour$name === void 0 ? null : _tour$name,
      _tour$startWayPointId = tour.startWayPointId,
      startWayPointId = _tour$startWayPointId === void 0 ? null : _tour$startWayPointId,
      _tour$endWayPointId = tour.endWayPointId,
      endWayPointId = _tour$endWayPointId === void 0 ? null : _tour$endWayPointId,
      _tour$plannedStartTim = tour.plannedStartTime,
      plannedStartTime = _tour$plannedStartTim === void 0 ? null : _tour$plannedStartTim,
      _tour$plannedEndTime = tour.plannedEndTime,
      plannedEndTime = _tour$plannedEndTime === void 0 ? null : _tour$plannedEndTime,
      dataRequest = tour.dataRequest,
      _tour$wayPoints = tour.wayPoints,
      wayPoints = _tour$wayPoints === void 0 ? [] : _tour$wayPoints;
  var startPOI = wayPoints.find(function (startPoi) {
    return startPoi.poiId === startWayPointId;
  });
  var endPOI = wayPoints.find(function (endPoi) {
    return endPoi.poiId === endWayPointId;
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-32 my-20 text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetRequest.header"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-lg"
    }, value);
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex mt-12 mb-4"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetRequest.tourId"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-1/2 font-bold"
    }, value, ":");
  }), /*#__PURE__*/_react["default"].createElement("span", null, name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex mb-4"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetRequest.request"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-1/2 font-bold"
    }, value, ":");
  }), /*#__PURE__*/_react["default"].createElement("span", null, portals[dataRequest === null || dataRequest === void 0 ? void 0 : dataRequest.haulerPortalId] && portals[dataRequest === null || dataRequest === void 0 ? void 0 : dataRequest.haulerPortalId].name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetRequest.startPOI"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-1/2 font-bold"
    }, value, ":");
  }), /*#__PURE__*/_react["default"].createElement("span", null, startPOI && startPOI.poiName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex mb-4"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetRequest.startTime"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-1/2 font-bold"
    }, value, ":");
  }), plannedStartTime && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: plannedStartTime,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", null, value);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetRequest.endPoi"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-1/2 font-bold"
    }, value, ":");
  }), /*#__PURE__*/_react["default"].createElement("span", null, endPOI && endPOI.poiName)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex mb-8"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetRequest.endTime"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-1/2 font-bold"
    }, value, ":");
  }), plannedEndTime && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedDate, {
    value: plannedEndTime,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    timeZone: user.timezone
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-1/2 mb-4"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseFilters.AssetFilter, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.assetRequest.asset"
    }),
    onChange: function onChange(e) {
      return onAssetChange(e);
    },
    tagName: "span"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.assetRequest.footer"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-gray-400"
    }, value);
  }));
};

exports.AssetRequest = AssetRequest;
AssetRequest.propTypes = {
  onAssetChange: _propTypes["default"].func,
  tour: _propTypes["default"].shape({
    name: _propTypes["default"].string,
    startWayPointId: _propTypes["default"].number,
    endWayPointId: _propTypes["default"].number,
    plannedStartTime: _propTypes["default"].string,
    plannedEndTime: _propTypes["default"].string,
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    dataRequest: _propTypes["default"].shape({
      haulerPortalId: _propTypes["default"].number
    })
  }).isRequired,
  user: _propTypes["default"].shape({
    timezone: _propTypes["default"].string
  }),
  portals: _propTypes["default"].shape({})
};
AssetRequest.defaultProps = {
  onAssetChange: function onAssetChange() {},
  user: {
    timezone: 'Europe/Berlin'
  },
  portals: {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AssetRequest);

exports["default"] = _default;